import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';

import { fetchHybridSearchData } from '../../../../common/actions/fetchHybridSearchData';
import { selectShouldKeepSsrListing } from '../../../../common/selectors/hybridSearch';
import { IApplicationState, TThunkDispatch } from '../../../../common/types/redux';
import { selectMapBounds } from '../../../selectors';
import { TMapBounds } from '../../../types/mapBounds';

export function usePinsFetching(): void {
  const dispatch = useDispatch<TThunkDispatch>();
  const store = useStore<IApplicationState>();
  const deviceType = useDeviceType();
  const { bounds, zoom } = useSelector<IApplicationState, TMapBounds>(selectMapBounds);
  const isFirstRunRef = React.useRef(true);

  React.useEffect(() => {
    if (!bounds || !zoom || !isFirstRunRef.current) {
      return;
    }

    isFirstRunRef.current = false;

    // deviceType передаём всегда — он нужен карте (fetchMapData). На мобвебе с уже загруженным
    // SSR-листингом (SEO) дополнительно отключаем перезагрузку листинга по карте: там карта и
    // листинг не синхронизируются, избегаем двойной загрузки (см. selectShouldKeepSsrListing).
    // В остальных случаях грузить ли листинг решает cascade fetchHybridSearchData по deviceType.
    const shouldKeepSsrListing = selectShouldKeepSsrListing(store.getState(), deviceType);

    if (shouldKeepSsrListing) {
      dispatch(fetchHybridSearchData({ deviceType, shouldLoadListingOverride: false }));
    } else {
      dispatch(fetchHybridSearchData({ deviceType }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bounds?.[0][0], bounds?.[0][1], bounds?.[1][0], bounds?.[1][1], deviceType]);
}
